// ------------Custom SLider-----------------
  window.initCustomSlider = function() {
  const track = document.querySelector(".custom_slider_track");
  const slides = Array.from(document.querySelectorAll(".pdp_slider_item"));
  const dotsContainer = document.querySelector(".custom_slider_dots");

  if (!track || slides.length === 0) return;

  let currentIndex = 0;
  let isDragging = false;
  let startPos = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID = null;

  function getSlideWidth() {
    return document.querySelector(".custom_slider_wrapper").offsetWidth;
  }

  function goToSlide(index) {
    currentIndex = index;
    setSliderPosition();
    updateDots();
  }

  function updateDots() {
    dotsContainer.innerHTML = ""; // reset
    slides.forEach((_, index) => {
      const dot = document.createElement("button");
      dot.addEventListener("click", () => goToSlide(index));
      if (index === currentIndex) dot.classList.add("active");
      dotsContainer.appendChild(dot);
    });
  }

  function setSliderPosition() {
    const slideWidth = getSlideWidth();
    currentTranslate = -currentIndex * slideWidth;
    prevTranslate = currentTranslate;
    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  function dragStart(event) {
    isDragging = true;
    startPos = getPositionX(event);
    animationID = requestAnimationFrame(animation);
    track.style.transition = "none";
    track.classList.add("grabbing");
  }

  function dragMove(event) {
    if (!isDragging) return;
    const currentPosition = getPositionX(event);
    const diff = currentPosition - startPos;
    currentTranslate = prevTranslate + diff;
  }

  function dragEnd() {
    if (!isDragging) return;

    cancelAnimationFrame(animationID);
    isDragging = false;

    const movedBy = currentTranslate - prevTranslate;
    const slideWidth = getSlideWidth();
    const threshold = slideWidth / 4;

    if (movedBy < -threshold && currentIndex < slides.length - 1) currentIndex++;
    else if (movedBy > threshold && currentIndex > 0) currentIndex--;

    track.style.transition = "transform 0.3s ease";
    setSliderPosition();
    updateDots();
    track.classList.remove("grabbing");
  }

  function getPositionX(event) {
    return event.type.includes("mouse") ? event.pageX : event.touches[0].clientX;
  }

  function animation() {
    track.style.transform = `translateX(${currentTranslate}px)`;
    if (isDragging) requestAnimationFrame(animation);
  }

  // Setup events
  track.addEventListener("mousedown", dragStart);
  track.addEventListener("touchstart", dragStart, { passive: true });
  track.addEventListener("mouseup", dragEnd);
  track.addEventListener("touchend", dragEnd);
  track.addEventListener("mouseleave", dragEnd);
  track.addEventListener("mousemove", dragMove);
  track.addEventListener("touchmove", dragMove, { passive: false });

  window.addEventListener("resize", setSliderPosition);

  // Initialize
  setSliderPosition();
  updateDots();
}

// --------------------------X Product Swatches -----------------------------
 document.addEventListener("DOMContentLoaded", function () {
        document.addEventListener('click', async function (event) {
  const swatchElement = event.target.closest('a.swatch__link');
  if (!swatchElement) return;

  event.preventDefault();

  const section = swatchElement.closest('.shopify-section');
  if (!section) return;

  const sectionId =
    section.dataset.sectionId ||
    section.id.replace('shopify-section-', '');

  const pairedSection = document.querySelector('.product_paired_section');
  const pairedSectionId =
    pairedSection?.dataset.sectionId ||
    pairedSection?.id?.replace('shopify-section-', '');

  const gallerySection = document.querySelector('.product-gallery-section-pdp');
  const gallerySectionId =
    gallerySection?.dataset.sectionId ||
    gallerySection?.id?.replace('shopify-section-', '');

  const url = new URL(swatchElement.href, window.location.origin);
  url.searchParams.delete('section_id');
  const sectionsToLoad = [sectionId, pairedSectionId, gallerySectionId].filter(Boolean);
  url.searchParams.set('sections', sectionsToLoad.join(','));

  const thisForm = swatchElement.closest('form');
  thisForm
    ?.querySelectorAll('.swatches__swatch--color .swatches__form--label.itg-checked')
    ?.forEach(el => el.classList.remove('itg-checked'));

  swatchElement
    .closest('.swatches__swatch--color')
    ?.querySelector('.swatches__form--label')
    ?.classList.add('itg-checked');

  try {
    const response = await fetch(url.toString());
    const json = await response.json();

    const parser = new DOMParser();

    if (json[sectionId]) {
      const doc = parser.parseFromString(json[sectionId], 'text/html');
      const newProductSection = doc.querySelector('.product__section');
      const currentProductSection = section.querySelector('.product__section');

      if (newProductSection && currentProductSection) {
        currentProductSection.replaceWith(newProductSection);
      }
    }

    if (pairedSectionId && json[pairedSectionId]) {
      const doc = parser.parseFromString(json[pairedSectionId], 'text/html');
      const newPairedSection = doc.querySelector('.product_paired_section');

      if (newPairedSection && pairedSection) {
        pairedSection.replaceWith(newPairedSection);
      }
    }
    if (gallerySectionId && json[gallerySectionId]) {
      const doc = parser.parseFromString(json[gallerySectionId], 'text/html');
      const newgallerySection = doc.querySelector('.product-gallery-section-pdp');

      if (newgallerySection && gallerySection) {
        gallerySection.replaceWith(newgallerySection);
         window.updateGallerySliders();
      }
    }

    if (theme.ProductGallery) {
      theme.ProductGallery.init(
        section,
        sectionId,
        window.Events || {},
        window.Product || {}
      );
    }

    if (theme.Product) {
      theme.Product(document.querySelector('.product__section'));
    }

    if (window.initStickyBar) {
      window.initStickyBar();
    }

    if (window.initCustomSlider) {
      window.initCustomSlider();
    }

    const el = document.getElementById('dynamic-delivery-text');
    if(el) window.updateDeliveryDate(el);
    const cleanUrl = new URL(swatchElement.href, window.location.origin);
    cleanUrl.searchParams.delete('section_id');
    cleanUrl.searchParams.delete('sections');
    history.replaceState({}, '', cleanUrl.toString());

  } catch (error) {
    console.error(error);
  }
});

          window.initCustomSlider();
      });

    //   ------------------------------END X Swatches ----------------------------
  window.updateDeliveryDate = function (el, bufferDays = 5) {
    if (!el) return;

    const text = el.textContent;
    if (!text || !text.includes('[[date]]')) return;

    const today = new Date();
    const deliveryDate = new Date();
    deliveryDate.setDate(today.getDate() + bufferDays);

    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    const formattedDate = deliveryDate.toLocaleDateString('en-US', options);

    el.textContent = text.replace('[[date]]', formattedDate);
    el.style.visibility = 'visible';
  };
  const el = document.getElementById('dynamic-delivery-text');
  if(el) window.updateDeliveryDate(el);

function simulateClick(element) {
  ['mousedown', 'mouseup', 'click'].forEach(type => {
    const event = new MouseEvent(type, {
      bubbles: true,
      cancelable: true,
      view: window
    });
    element.dispatchEvent(event);
  });
}

function autoSelectSwatch() {
  const productOptions = [
    { className: "pro__shorts", value: "9 inch" },
    { className: "pro__mens-active-shorts", value: '9"' },
    { className: "pro__mens-cloud-fleece-shorts", value: '9"' },
    { className: "pro__traditional-pants", value: "32" },
    { className: "pro__city-joggers", value: "32" },
    { className: "pro__mens-tops", value: "Large" },
    { className: "pro__mens-joggers", value: "Regular" }, // no value needed
  ];

  const match = productOptions.find(opt =>
    document.querySelector('.product__section-content')?.classList.contains(opt.className)
  );
  if (!match) return;

  // helper: simulate label click for a swatch by value in given option-index
  function selectSwatch(optionIndex, desiredValue) {
    const container = document.querySelector(
      `.product__variants-swatches .swatches__container[data-option-index="${optionIndex}"]`
    );
    if (!container) return;

    const exactInput = container.querySelector(
      `.swatches__form--input[value="${desiredValue}"]:not(.soldout)`
    );
    if (exactInput) {
      const label = exactInput.closest('.swatches__swatch--regular')?.querySelector('label');
      if (label) simulateClick(label);
      return;
    }

    for (const swatch of container.querySelectorAll('.swatches__swatch--regular')) {
      if (!swatch.classList.contains('soldout')) {
        const label = swatch.querySelector('label');
        if (label) {
          simulateClick(label);
          return;
        }
      }
    }
  }

  // logic based on class
  
    // regular behavior: first match.value from index 3, then 32 from index 2
    // first: product-specific value on index 3
selectSwatch(3, match.value);

// second: only run the one that applies
if (["pro__traditional-pants", "pro__city-joggers", "pro__mens-joggers", "pro__shorts", "pro__mens-active-shorts", "pro__mens-cloud-fleece-shorts"].includes(match.className)) {
  selectSwatch(2, "32");
}

if (["pro__mens-tops"].includes(match.className)) {
  selectSwatch(2, "Large");
}

  
}



// helper: fully simulate a real user click
function simulateClick(element) {
  element.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
  element.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
  element.dispatchEvent(new MouseEvent('click', { bubbles: true }));
}

// Function to initialize Flickity slider



 window.initStickyBar = function() {
    let addToCartBtn = document.querySelector(".product-add #addToCart");
    let stickyBar = document.querySelector(".pdp_sticky--bar");

    if (!addToCartBtn || !stickyBar) {
        console.warn("Sticky bar init skipped. Elements not found.");
        return;
    }

    function toggleStickyBar() {
        let addToCartRect = addToCartBtn.getBoundingClientRect();
        let addToCartPosition = addToCartRect.top + window.scrollY;
        let scrollPosition = window.scrollY;
        let threshold = 50;

        if (scrollPosition > addToCartPosition - threshold) {
            stickyBar.classList.add("show2");
        } else {
            stickyBar.classList.remove("show2");
        }
    }

    stickyBar.style.visibility = "hidden";

    requestAnimationFrame(() => {
        toggleStickyBar();
        stickyBar.style.visibility = "visible";
    });

    window.addEventListener("scroll", toggleStickyBar);
}

document.addEventListener("DOMContentLoaded", window.initStickyBar);

 document.addEventListener("click", function (event) {
    const addToCartButton = event.target.closest("#addToCart");

    if (addToCartButton) {
        addToCartButton.value = "Adding...";

        const cartDrawer = document.querySelector(".f-cart-drawer");

        if (cartDrawer) {
            // Create a MutationObserver to watch for class changes
            const observer = new MutationObserver(function (mutationsList) {
                for (let mutation of mutationsList) {
                    if (mutation.type === "attributes" && cartDrawer.classList.contains("f-cart-drawer--active")) {
                        addToCartButton.value = "Add to Cart"; // Reset the button text
                        observer.disconnect(); // Stop observing once the class is added
                    }
                }
            });

            // Start observing the cart drawer for class attribute changes
            observer.observe(cartDrawer, { attributes: true, attributeFilter: ["class"] });
        }
    }
});


document.addEventListener('click', function (event) {
const stickyAtc = event.target.closest('.sticky-atc'); 

if (stickyAtc) { 
const originalText = stickyAtc.innerHTML; 
stickyAtc.innerHTML = 'Adding...'; 
const addToCartButton = document.querySelector('.product__section-details__inner #addToCart');

if (addToCartButton) { 
const cartDrawer = document.querySelector('.f-cart-drawer');
if (cartDrawer) {
const observer = new MutationObserver(() => {
if (cartDrawer.classList.contains('f-cart-drawer--active')) {
stickyAtc.innerHTML = originalText; // Restore button text
observer.disconnect(); // Stop observing
}
});

observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
}
addToCartButton.click();
}
}
});
document.addEventListener("DOMContentLoaded", function () {
      let maxHeight = 0;

    document.querySelectorAll(".fl_look .product-details").forEach(div => {
        let height = div.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
    });

    document.querySelectorAll(".fl_look .product-details").forEach(div => {
        div.style.height = maxHeight + "px";
    });
});

 

 document.addEventListener('click',e=>{
    if(e.target.classList.contains('product__image')){
      localStorage.setItem('gallery',true)
    } 
  }) 
  window.addEventListener('popstate', (e) => {
    if(localStorage.getItem('gallery') == 'true'){ 
      localStorage.setItem('gallery',false)
    }else{
      window.location.reload()
    } 
  });


document.addEventListener("DOMContentLoaded", function () {
  const productOptions = [
    { className: "pro__shorts", value: "9 inch" },
    { className: "pro__mens-active-shorts", value: '9"' },
    { className: "pro__mens-cloud-fleece-shorts", value: '9"' },
    { className: "pro__traditional-pants", value: "32" },
    { className: "pro__city-joggers", value: "32" },
    { className: "pro__mens-tops", value: "Large" },
    { className: "pro__mens-joggers", value: "Regular" }, // no value needed
  ];

  // 1) figure out which product-type we’re on
  const match = productOptions.find(opt =>
    document.querySelector('.product__section-content')?.classList.contains(opt.className)
  );
  if (!match) return;

  // 2) helper to select a swatch (or fallback) in a given option-index
  function selectSwatch(optionIndex, desiredValue) {
    const container = document.querySelector(
      `.product__variants-swatches .swatches__container[data-option-index="${optionIndex}"]`
    );
    if (!container) return;

    // try to click the exact match first (only if not sold‑out)
    const exact = container.querySelector(
      `.swatches__form--input[value="${desiredValue}"]:not(.soldout)`
    );
    if (exact) {
      exact.closest('.swatches__swatch--regular')
           .querySelector('label')
           .click();
      return;
    }

    // otherwise pick the first non-sold‑out swatch
    for (let swatch of container.querySelectorAll('.swatches__swatch--regular')) {
      if (!swatch.classList.contains('soldout')) {
        swatch.querySelector('label')?.click();
        return;
      }
    }
  }

  // first: product-specific value on index 3
selectSwatch(3, match.value);

// second: only run the one that applies
if (["pro__traditional-pants", "pro__city-joggers", "pro__mens-joggers", "pro__shorts", "pro__mens-active-shorts", "pro__mens-cloud-fleece-shorts"].includes(match.className)) {
  selectSwatch(2, "32");
}

if (["pro__mens-tops"].includes(match.className)) {
  selectSwatch(2, "Large");
}

});
